"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgTrustZonesListCtl = /** @class */ (function (_super) {
    __extends(CfgTrustZonesListCtl, _super);
    function CfgTrustZonesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_zone_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.zone_code; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_color = UIUtils_1.UIUtils.IProp2Str(function (o) { o.color; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_default = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_default; });
        _this.dk_is_prohibit_dep_bonuses = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_prohibit_dep_bonuses; });
        _this.dk_is_prohibit_nodep_bonuses = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_prohibit_nodep_bonuses; });
        _this.dk_is_prohibit_tournaments = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_prohibit_tournaments; });
        _this.dk_is_prohibit_cashback_bonuses = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_prohibit_cashback_bonuses; });
        _this.dk_is_prohibit_jackpots = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_prohibit_jackpots; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgTrustZonesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CfgTrustZonesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CfgTrustZonesListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListAppTrustZonesGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    zone_code: resp.list[i].zone_code,
                    order_number: resp.list[i].order_number,
                    is_default: resp.list[i].is_default,
                    color: resp.list[i].color,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_prohibit_dep_bonuses: resp.list[i].is_prohibit_dep_bonuses,
                    is_prohibit_nodep_bonuses: resp.list[i].is_prohibit_nodep_bonuses,
                    is_prohibit_tournaments: resp.list[i].is_prohibit_tournaments,
                    is_prohibit_cashback_bonuses: resp.list[i].is_prohibit_cashback_bonuses,
                    is_prohibit_jackpots: resp.list[i].is_prohibit_jackpots,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgTrustZonesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddAppTrustZone.exec({
            data: {
                title: data.title,
                zone_code: data.zone_code,
                order_number: data.order_number,
                is_default: data.is_default,
                color: data.color,
                description: data.description,
                is_prohibit_dep_bonuses: data.is_prohibit_dep_bonuses,
                is_prohibit_nodep_bonuses: data.is_prohibit_nodep_bonuses,
                is_prohibit_tournaments: data.is_prohibit_tournaments,
                is_prohibit_cashback_bonuses: data.is_prohibit_cashback_bonuses,
                is_prohibit_jackpots: data.is_prohibit_jackpots,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                zone_code: data.zone_code,
                is_default: data.is_default,
                color: data.color,
                order_number: data.order_number,
                description: data.description,
                is_prohibit_dep_bonuses: data.is_prohibit_dep_bonuses,
                is_prohibit_nodep_bonuses: data.is_prohibit_nodep_bonuses,
                is_prohibit_tournaments: data.is_prohibit_tournaments,
                is_prohibit_cashback_bonuses: data.is_prohibit_cashback_bonuses,
                is_prohibit_jackpots: data.is_prohibit_jackpots,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgTrustZonesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditAppTrustZone.exec({
                data: {
                    app_trust_zone_id: data.key,
                    title: data.title,
                    description: data.description,
                    is_default: data.is_default,
                    color: data.color,
                    zone_code: data.zone_code,
                    order_number: data.order_number,
                    is_prohibit_dep_bonuses: data.is_prohibit_dep_bonuses,
                    is_prohibit_nodep_bonuses: data.is_prohibit_nodep_bonuses,
                    is_prohibit_tournaments: data.is_prohibit_tournaments,
                    is_prohibit_cashback_bonuses: data.is_prohibit_cashback_bonuses,
                    is_prohibit_jackpots: data.is_prohibit_jackpots,
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.zone_code = data.zone_code;
                _tmp.order_number = data.order_number;
                _tmp.is_default = data.is_default;
                _tmp.color = data.color;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_prohibit_dep_bonuses = data.is_prohibit_dep_bonuses;
                _tmp.is_prohibit_nodep_bonuses = data.is_prohibit_nodep_bonuses;
                _tmp.is_prohibit_tournaments = data.is_prohibit_tournaments;
                _tmp.is_prohibit_cashback_bonuses = data.is_prohibit_cashback_bonuses;
                _tmp.is_prohibit_jackpots = data.is_prohibit_jackpots;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgTrustZonesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgTrustZonesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteAppTrustZone.exec({
                data: {
                    app_trust_zone_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgTrustZonesListCtl.prototype.SetIsDefault = function (key, IsDefault, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetAppTrustZoneIsDefault.exec({ data: { app_trust_zone_id: key, is_default: IsDefault } }, function (resp) {
                _tmp.is_default = IsDefault;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgTrustZonesListCtl.prototype.SetOrderNumber = function (key, orderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetAppTrustZoneOrderNumber.exec({ data: { app_trust_zone_id: key, order_number: orderNumber } }, function (resp) {
                _tmp.order_number = orderNumber;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CfgTrustZonesListCtl;
}(BaseController_1.BaseController));
exports.CfgTrustZonesListCtl = CfgTrustZonesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_trust_zones/ctl/CfgTrustZonesListCtl.ts
// module id = 1060
// module chunks = 0